


import React, { useEffect} from 'react'
import { useNavigate } from 'react-router-dom';

import company1 from '../assets/companies/company1.png';
import company2 from '../assets/companies/company2.png';
import company3 from '../assets/companies/company3.png';
import company4 from '../assets/companies/company4.png';
import company5 from '../assets/companies/company5.jpeg';
import company6 from '../assets/companies/company6.png';

import { PAYMENT_URL } from '../constants';

const companies = [
  { id: 1, name: 'Company 1', logo: company1, slug: 'company-1', paymentLink: PAYMENT_URL },
  { id: 2, name: 'Company 2', logo: company2, slug: 'company-2', paymentLink: PAYMENT_URL },
  { id: 3, name: 'Company 3', logo: company3, slug: 'company-3', paymentLink: PAYMENT_URL },
  { id: 4, name: 'Company 4', logo: company4, slug: 'company-4', paymentLink: PAYMENT_URL },
  { id: 5, name: 'Company 5', logo: company5, slug: 'company-5', paymentLink: PAYMENT_URL },
  { id: 6, name: 'Company 6', logo: company6, slug: 'company-6', paymentLink: PAYMENT_URL },
];

export default function Companies() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      navigate('/');
    }
  }, [navigate]);

  const handleSelect = (company) => {
    navigate(`/form/${company.slug}`, { state: { company } });
  };

  return (
    <div className="min-h-screen px-6 py-10 bg-gray-50">
      <h2 className="text-2xl font-medium text-center mb-8 text-gray-800">Select a Company</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {companies.map((company) => (
          <div
            key={company.id}
            onClick={() => handleSelect(company)}
            className="bg-white aspect-square p-6 rounded-2xl shadow-md hover:shadow-xl cursor-pointer transition duration-300 flex items-center justify-center"
          >
            <img
              src={company.logo}
              alt={company.name}
              className="max-h-24 object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
